import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-field"
export default class extends Controller {
  static targets = ['label', 'modal']
  
  connect() {
    this.inputTextReplaceLoad();
    this.inputTextReplaceChange();
  }

  open() {
    this.modalTarget.classList.add('open');
  }

  close() {
    this.modalTarget.classList.remove('open');
  }

  inputTextReplaceLoad() {
    let i = 0;
    let checkboxes = this.element.querySelectorAll('input[type=checkbox]');

    checkboxes.forEach(box => {
      let text = box.closest('label').innerText;
      if(box.checked){
        i++;
        if(i > 1){
          this.labelTarget.innerText = 'Multiple';
        } else if (i == 1){
          this.labelTarget.innerText = text;
        }
      };
    });
    
  }

  inputTextReplaceChange() {
    let checkboxes = this.element.querySelectorAll('input[type=checkbox]');
    let i = 0;
    checkboxes.forEach(box => {
      let text = box.closest('label').innerText;
      box.addEventListener('change', () => {
        if(box.checked){
          i++;
          if(i > 1){
            this.labelTarget.innerText = 'Multiple';
          } else if (i == 1){
            this.labelTarget.innerText = text;
          }
        } else if(!box.checked) {
          if(i > 0){
            i--;
          }
          if(i > 1){
            this.labelTarget.innerText = 'Multiple';
          } else if (i <= 1){
            let x = 0;
            checkboxes.forEach(box => {
              let text2 = box.closest('label').innerText;
              if(box.checked){
                x++
                this.labelTarget.innerText = text2;
              }
            });
            if(x == 0){
              this.labelTarget.innerText = "Any";
            }
          }
        }
      });
    });
  }
}
